import React from 'react';

import {LockOutlined} from '@ant-design/icons/lib';
import {Button, Card} from 'antd';
import {confirmSignIn} from 'aws-amplify/auth';
import type {FormikProps} from 'formik';
import {withFormik} from 'formik';
import {Form, FormItem, Input} from 'formik-antd';
import * as yup from 'yup';

import {AnchorLink} from '../AnchorLink';

import {getErrorInfo} from 'lib/errorUtils';
import type {IAuthProps} from 'types';
import {AuthState} from 'types';

interface IFormValues {
  password: string;
  passwordConfirm: string;
}

// eslint-disable-next-line react-refresh/only-export-components
const C: React.FC<FormikProps<IFormValues> & IAuthProps> = ({
  isSubmitting,
  setState: setStateCallback,
  email
}) => {
  const setState = setStateCallback;
  const backToSignIn = (e: React.SyntheticEvent) => {
    e.preventDefault();
    setState({authState: AuthState.signIn, email});
  };
  return (
    <Card
      title="Set a new password"
      extra={<AnchorLink onClick={backToSignIn}>Back to Sign In</AnchorLink>}>
      <Form layout="vertical">
        <FormItem name="password" label="Password">
          <Input.Password
            autoFocus
            name="password"
            type="password"
            size="large"
            prefix={<LockOutlined />}
          />
        </FormItem>
        <FormItem name="passwordConfirm" label="Password confirmation">
          <Input.Password
            name="passwordConfirm"
            type="password"
            size="large"
            prefix={<LockOutlined />}
          />
        </FormItem>
        <Button block size="large" type="primary" loading={isSubmitting} htmlType="submit">
          Change password
        </Button>
      </Form>
    </Card>
  );
};

const schema = yup.object().shape({
  password: yup.string().min(6).required(),
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref('password')], "passwords don't match")
    .required('password confirmation is required')
});

export const RequireNewPassword = withFormik<IAuthProps, IFormValues>({
  validationSchema: schema,
  mapPropsToValues: () => ({password: '', passwordConfirm: ''}),
  handleSubmit: async ({password}, {props, setErrors, setSubmitting}) => {
    try {
      await confirmSignIn({challengeResponse: password});
      props.setState({authState: AuthState.signIn, email: props.email});
    } catch (error: unknown) {
      // Safely extract error information
      const {name: errorName, message: errorMessage} = getErrorInfo(error);

      if (errorName === 'CodeMismatchException') {
        setErrors({password: errorMessage});
        return;
      }
      setErrors({password: errorMessage});
    } finally {
      setSubmitting(false);
    }
  }
})(C);
